import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import personaService from "../services/persona.service";

const initialState = {
    personas: [],
    personaPorCedula: null, // Para almacenar la persona obtenida por cédula
    isErrorCedula: false, // Para manejar errores al buscar por cédula
    isLoadingCedula: false, // Para manejar el estado de carga al buscar por cédula
    messageCedula: '', // Mensaje de error específico para la búsqueda por cédula
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
    currentPage: 1,
    totalRows: 0
};


export const getPersonas = createAsyncThunk(
    "personas/getPersonas",
    async (data, thunkAPI) => {
        try {
            return await personaService.getAllPersonas(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createPersona = createAsyncThunk(
    "persona/create",
    async ( personaData, thunkAPI ) => {
        try {
            return await personaService.createPersona(personaData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updatePersona = createAsyncThunk(
    "persona/update",
    async (personaData, thunkAPI ) => {
        try {
            return await personaService.updatePersona(personaData);
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deletePersona = createAsyncThunk(
    "persona/delete",
    async (id, thunkAPI) => {
        try {
            return await personaService.deletePersona(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getPersonaByCedula = createAsyncThunk(
    "persona/getPersonaByCedula",
    async (cedula, thunkAPI) => {
        try {   
            return await personaService.getPersonaByCedula(cedula);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
const personaSlice = createSlice({
    name: "persona",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPersonas.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPersonas.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.personas = action.payload.data; // Asignar los datos de personas
                state.currentPage = action.payload.pagination.currentPage; // Asignar la página actual
                state.totalRows = action.payload.pagination.totalRows; // Asignar el total de filas
            })
            .addCase(getPersonas.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createPersona.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPersona.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.personas.push(action.payload);
            })
            .addCase(createPersona.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updatePersona.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePersona.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                const index = state.personas.findIndex((persona) => persona.id === action.payload.id);
                if (index !== -1) {
                    state.personas[index] = action.payload; // Actualizar la persona modificada
                }
            })
            .addCase(updatePersona.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deletePersona.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePersona.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.personas = state.personas.filter((persona) => persona.id !== action.payload.id); // Eliminar la persona
            }
            )
            .addCase(deletePersona.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getPersonaByCedula.pending, (state) => {
                state.isLoadingCedula = true;
            })
            .addCase(getPersonaByCedula.fulfilled, (state, action) => {
                state.isLoadingCedula = false;
                state.isErrorCedula = false;
                state.personaPorCedula = action.payload.data; // Asignar los datos de la persona por cédula
            })
            .addCase(getPersonaByCedula.rejected, (state, action) => {
                state.isLoadingCedula = false;
                state.isErrorCedula = true;
                state.messageCedula = action.payload; // Mensaje de error
            });
    }
});
export const { reset } = personaSlice.actions;
export default personaSlice.reducer;